export enum FeatureFilterItemType {
    Audio,
    Display,
    Video,
    Accessible,
}

export interface FeatureFilterItem {
    feature: FeatureFilterItemType;
    icon: string;
    label: string;
    enabled?: boolean;
}
